<app-close-button (closeButton)="close()"></app-close-button>
<div class="select_delivery_time_block">
  <div class="select_delivery_time_block--title">
    {{'navbar.delivery_date.select_delivery_time' | translate}}
  </div>
  <div class="select_delivery_time_block--content">
    <div class="items flex_align_center" *ngFor="let time of data;let i=index">
        <label class="radio bold text_normal_sub pointer">
          <input type="radio" class="pointer" name="time"
                 [value]="time"
                 [(ngModel)]="itemStartValue"
          >
          <span class="checkmark" [ngClass]="{checked: (time == itemStartValue)}">
            <img src="assets/images/icons/checkbox_icon.svg">
          </span>
        </label>
        <div class="ml_16 time">
          {{time.start | toLocalDate :'HH:mm' : false : true}}
          - {{time.end | toLocalDate :'HH:mm' : false : true }}
        </div>
    </div>
  </div>
  <div class="select_delivery_time_block--bottom">
    <button (click)="confirmTime()" [disabled]="!itemStartValue">
      {{'buttons.confirm' | translate}}
    </button>
  </div>
</div>
